import { render, staticRenderFns } from "./EditReciboTable.vue?vue&type=template&id=5f1526d1&scoped=true"
import script from "./EditReciboTable.vue?vue&type=script&lang=js"
export * from "./EditReciboTable.vue?vue&type=script&lang=js"
import style0 from "./EditReciboTable.vue?vue&type=style&index=0&id=5f1526d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1526d1",
  null
  
)

export default component.exports